import { useInfiniteLabelTopPacks } from '@bpm-web-app/swr-hooks';
import { useRouter } from 'next/router';
import { createAppRoutes, DEFAULT_PACKS_LIMIT } from '@bpm-web-app/utils';
import { useCallback, useMemo } from 'react';
import { SeeMoreLayout } from '../../see-more-layout/see-more-layout';
import { LoadMore } from '../../shared/load-more/load-more';
import Title from '../../title/title';

export function TopPacksByLabelPage() {
    const router = useRouter();
    const { slug } = router.query;

    const {
        data: topPacks,
        isLoadingMore,
        isLastPage,
        setSize,
    } = useInfiniteLabelTopPacks(slug as string, {
        limit: DEFAULT_PACKS_LIMIT,
    });

    const flatPacks = useMemo(() => topPacks?.flatMap((data) => data.data), [topPacks]);

    const pagination = useMemo(() => topPacks?.[0]?.pagination, [topPacks]);

    const handleLoadMore = useCallback(() => {
        if (!isLoadingMore && !isLastPage) {
            setSize((prevSize) => prevSize + 1);
        }
    }, [isLastPage, isLoadingMore, setSize]);

    return (
        <>
            <Title platform="create" title={`${slug}`} />
            <SeeMoreLayout
                contentType="pack"
                pageTitle={`${slug} - Top Packs`}
                count={pagination?.total || 0}
                itemBasePath={createAppRoutes.packs}
                data={flatPacks}
            />
            <LoadMore onLoadMore={handleLoadMore} />
        </>
    );
}
